import script from "./AdminInvoicesQuery.vue?vue&type=script&lang=js"
export * from "./AdminInvoicesQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__